import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface PartErrorState {
  hasError: boolean;
  message: string;
}

interface ErrorState {
  DevicePageTopLeft: PartErrorState;
  DevicePageTopCenter: PartErrorState;
  DevicePageTopRight: PartErrorState;
  DevicePageBottomLeft: PartErrorState;
  DevicePageBottomCenter: PartErrorState;
  DevicePageBottomRight: PartErrorState;
}

const initialState: ErrorState = {
  DevicePageTopLeft: { hasError: false, message: '' },
  DevicePageTopCenter: { hasError: false, message: '' },
  DevicePageTopRight: { hasError: false, message: '' },
  DevicePageBottomLeft: { hasError: false, message: '' },
  DevicePageBottomCenter: { hasError: false, message: '' },
  DevicePageBottomRight: { hasError: false, message: '' },
};

const errorSlice = createSlice({
  name: 'errors',
  initialState,
  reducers: {
    reportError: (state, action: PayloadAction<{ partKey: string; message: string; error: boolean }>) => {
      const { partKey, message, error } = action.payload;
      state[partKey] = { hasError: true, message: message };
    },
    clearError: (state, action: PayloadAction<{ partKey: keyof ErrorState }>) => {
      const { partKey } = action.payload;
      state[partKey] = { hasError: false, message: '' };
    },
  },
});

export const { reportError, clearError } = errorSlice.actions;
export default errorSlice.reducer;
